export default __webpack_public_path__ + "static/8-754711bdf68c77a2cc61e0024fab5cdb.jpg";